import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function User2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M8.94286 8.30769C8.94286 4.27846 12.1089 1 16 1C19.8911 1 23.0571 4.27846 23.0571 8.30769C23.0571 12.3369 19.8911 15.6154 16 15.6154C12.1089 15.6154 8.94286 12.3369 8.94286 8.30769ZM20.4571 17.9231H11.5429C6.83314 17.9231 3 21.8923 3 26.7692C3 29.1031 4.83189 31 7.08571 31H24.9143C27.1681 31 29 29.1031 29 26.7692C29 21.8923 25.1669 17.9231 20.4571 17.9231Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
